<template>
  <div style="height: 100%">
    <div class="mb-3">
      <v-autocomplete
        class="fix-google-chrome"
        v-model="selectedHardwareGroup"
        :items="hardwaresGroup"
        item-text="title_th"
        item-value="hardware_group_uuid"
        outlined
        dense
        hide-details
        label="กลุ่ม Device"
        @change="handleSelectedHardwareGroup"
        :loading="loadingSelectedHardwareGroup"
      >
      </v-autocomplete>
    </div>
    <div class="px-4 pb-2 d-flex justify-space-between align-center">
      <v-checkbox
        v-model="checkedAll"
        hide-details
        dense
        @change="handleCheckAll($event)"
        :disabled="!selectedHardwareGroup || totalHardwaresGroupMember === 0"
      >
        <template v-slot:label>
          <span class="body-2">เลือกทั้งหมด</span>
        </template>
      </v-checkbox>
      <div>
        <span class="caption grey--text text--darken-2"
          >{{
            checkedAll ? totalHardwaresGroupMember : selectedHardwares.length
          }}
          รายการ</span
        >
      </div>
    </div>
    <div
      :style="`height: calc(100% - 190px); border: 1px solid #bdbdbd; ${
        checkedAll ? 'overflow-y: hidden' : 'overflow-y: auto'
      }`"
    >
      <DynamicScroller
        :items="hardwaresGroupMember"
        :min-item-size="pagination.limit"
        key-field="hardware_uuid"
        class="px-2 py-2"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :data-index="index"
          >
            <div>
              <div
                class="px-2 py-2 d-flex justify-space-between"
                v-observe-visibility="
                  item.hardware_uuid ===
                    lastHardwaresGroupMember.hardware_uuid &&
                  !isHardwaresGroupMemberLastPage
                    ? infiniteScrollHandlerHardwaresGroupMember
                    : false
                "
              >
                <div class="d-flex">
                  <v-checkbox
                    v-model="checkedHardware[item.hardware_uuid]"
                    @change="handleCheckHardware($event, item)"
                    class="pt-0 mt-0"
                    hide-details
                    dense
                    :id="item.hardware_uuid"
                    :value="checkedAll"
                    :disabled="checkedAll"
                  ></v-checkbox>
                  <label :for="item.hardware_uuid" style="margin-top: 1px">
                    <div class="body-2">
                      {{ item.hardware_code }} - {{ item.title_th }}
                    </div>
                    <div class="body-2 grey--text">
                      รุ่น:
                      {{ item.hardware_model ? item.hardware_model.title : '' }}
                    </div>
                  </label>
                </div>
              </div>
              <v-divider></v-divider>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
      <div v-if="pagination.isLoading">
        <div class="px-2">
          <v-card
            color="#f5f5f5"
            v-for="num in 10"
            :key="num"
            outlined
            class="px-4 py-2 mb-2"
          >
            <Skeleton width="200px" />
            <Skeleton :count="1" />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import { mapActions } from 'vuex'

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  components: {
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
  },
  props: {
    selectedHardwares: {
      type: Array,
      required: true,
    },
    accessAuthority: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      checkedAll: false,
      loadingSelectedHardwareGroup: false,
      selectedHardwareGroup: null,
      checkedHardware: {},
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      hardwaresGroupMember: [],
      totalHardwaresGroupMember: 0,
    }
  },
  computed: {
    lastHardwaresGroupMember() {
      const [lastItem] = this.hardwaresGroupMember.slice(-1)
      return lastItem || {}
    },
    isHardwaresGroupMemberLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalHardwaresGroupMember / this.pagination.limit)
      )
    },
    hardwaresGroup() {
      return this.$store.state.hardwaresGroup.hardwaresGroup
    },
  },
  async created() {
    await this.getHardwaresGroup()
  },
  methods: {
    ...mapActions({
      fetchHardwaresGroup: 'hardwaresGroup/fetchHardwaresGroup',
      fetchHardwaresGroupMember: 'hardwaresGroup/fetchHardwaresGroupMember',
    }),
    async handleSelectedHardwareGroup() {
      this.$emit('onClearHardwares')
      this.$emit('onClearHardwareGroup')
      this.checkedAll = false
      this.checkedHardware = {}

      this.hardwaresGroupMember = []
      this.totalHardwaresGroupMember = 0
      this.pagination.currentPage = 1
      await this.getHardwaresGroupMember()
    },
    handleCheckAll(value) {
      this.$emit('onCheckAllHardwareGroup', value, this.selectedHardwareGroup)
      // this.checkedHardware = {}
    },
    handleCheckHardware(value, hardware) {
      this.$emit('onCheckHardware', value, hardware)
    },
    async getHardwaresGroup() {
      try {
        this.loadingSelectedHardwareGroup = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'access-authority-hardware-to-list-access-hardware-group',
          },
        }

        await this.fetchHardwaresGroup(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingSelectedHardwareGroup = false
      }
    },
    async getHardwaresGroupMember() {
      try {
        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          hardware_group_uuid: this.selectedHardwareGroup,
          params: {
            dpc: 'access-authority-hardware-to-list-access-hardware-group-member',
            exclude_authority_uuid: this.accessAuthority.authority_uuid,
            limit: `${this.pagination.limit},${
              (this.pagination.currentPage - 1) * this.pagination.limit
            }`,
            is_policy_tag: true,
          },
        }
        const { total: totalHardwaresGroupMember, data: hardwaresGroupMember } =
          await this.fetchHardwaresGroupMember(payload)
        this.totalHardwaresGroupMember = totalHardwaresGroupMember
        this.setHardwaresGroupMember(hardwaresGroupMember)
        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextHardwaresGroupMember() {
      try {
        this.pagination.currentPage += 1

        await this.getHardwaresGroupMember()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setHardwaresGroupMember(hardwaresGroupMember) {
      this.hardwaresGroupMember = [
        ...this.hardwaresGroupMember,
        ...hardwaresGroupMember,
      ]
    },
    infiniteScrollHandlerHardwaresGroupMember(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextHardwaresGroupMember()
      }
    },
  },
}
</script>
